var map = {
	"./crm_sales1.png": "8d42",
	"./crm_sales2.png": "7f7c",
	"./crm_sales3.png": "8ed0",
	"./crm_sales4.png": "cbbd",
	"./crm_sales5.png": "bfed"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cb0f";